import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66669 5.33337C2.66669 5.05723 2.89054 4.83337 3.16669 4.83337H4.83335C5.1095 4.83337 5.33335 5.05723 5.33335 5.33337C5.33335 5.60952 5.1095 5.83337 4.83335 5.83337H3.16669C2.89054 5.83337 2.66669 5.60952 2.66669 5.33337Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00002 5.33337C8.00002 5.05723 8.22388 4.83337 8.50002 4.83337H12.8334C13.1095 4.83337 13.3334 5.05723 13.3334 5.33337C13.3334 5.60952 13.1095 5.83337 12.8334 5.83337H8.50002C8.22388 5.83337 8.00002 5.60952 8.00002 5.33337Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66669 4.33337C6.1144 4.33337 5.66669 4.78109 5.66669 5.33337C5.66669 5.88566 6.1144 6.33337 6.66669 6.33337C7.21897 6.33337 7.66669 5.88566 7.66669 5.33337C7.66669 4.78109 7.21897 4.33337 6.66669 4.33337ZM4.66669 5.33337C4.66669 4.2288 5.56212 3.33337 6.66669 3.33337C7.77126 3.33337 8.66669 4.2288 8.66669 5.33337C8.66669 6.43794 7.77126 7.33337 6.66669 7.33337C5.56212 7.33337 4.66669 6.43794 4.66669 5.33337Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66669 10.6667C2.66669 10.3906 2.89054 10.1667 3.16669 10.1667H8.16669C8.44283 10.1667 8.66669 10.3906 8.66669 10.6667C8.66669 10.9428 8.44283 11.1667 8.16669 11.1667H3.16669C2.89054 11.1667 2.66669 10.9428 2.66669 10.6667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3334 10.6667C11.3334 10.3906 11.5572 10.1667 11.8334 10.1667H12.8334C13.1095 10.1667 13.3334 10.3906 13.3334 10.6667C13.3334 10.9428 13.1095 11.1667 12.8334 11.1667H11.8334C11.5572 11.1667 11.3334 10.9428 11.3334 10.6667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 9.66671C9.44774 9.66671 9.00002 10.1144 9.00002 10.6667C9.00002 11.219 9.44774 11.6667 10 11.6667C10.5523 11.6667 11 11.219 11 10.6667C11 10.1144 10.5523 9.66671 10 9.66671ZM8.00002 10.6667C8.00002 9.56214 8.89545 8.66671 10 8.66671C11.1046 8.66671 12 9.56214 12 10.6667C12 11.7713 11.1046 12.6667 10 12.6667C8.89545 12.6667 8.00002 11.7713 8.00002 10.6667Z"
      fill="currentColor"
    />
  </SvgIcon>
));
